import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\ExecuteBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/ExecuteBatchOperationController.php
* @route '/api/batch-operations/execute'
*/
const ExecuteBatchOperationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExecuteBatchOperationController.url(options),
    method: 'post',
})

ExecuteBatchOperationController.definition = {
    methods: ["post"],
    url: '/api/batch-operations/execute',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BatchOperation\ExecuteBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/ExecuteBatchOperationController.php
* @route '/api/batch-operations/execute'
*/
ExecuteBatchOperationController.url = (options?: RouteQueryOptions) => {
    return ExecuteBatchOperationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\ExecuteBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/ExecuteBatchOperationController.php
* @route '/api/batch-operations/execute'
*/
ExecuteBatchOperationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExecuteBatchOperationController.url(options),
    method: 'post',
})

export default ExecuteBatchOperationController